<template>
  <div class="customer">
    <el-card>
      <div class="cell_item">
        <div class="cell_label">用户编码</div>
        <div class="cell_content">
          {{params.code}}
        </div>
      </div>
      <div class="cell_item">
        <div class="cell_label">用户卡号</div>
        <div class="cell_content">
          {{params.yhkh}}
        </div>
      </div>

      <div class="cell_item">
        <div class="cell_label">用户名称</div>
        <div class="cell_content">
          {{$formatName(params.name)}}
        </div>
      </div>
      <div class="cell_item">
        <div class="cell_label">用户地址</div>
        <div class="cell_content">
          {{params.address}}
        </div>
      </div>
    </el-card>
    <p class="tit_tip" v-if="ifUse!=1">请选择分组信息</p>
    <el-card v-if="ifUse!=1">
      <div class="div_fenzu">
        <span>分组</span> <span @click="sexVisible=true">{{relationShip}}<i class="el-icon-arrow-right"></i></span>
      </div>
      <mt-popup
        position="bottom"
        v-model="sexVisible">
        <mt-picker :slots="slots" @change="onValuesChange"></mt-picker>
      </mt-popup>
    </el-card>
    <button @click="bindUser" class="btn_bind" type="primary">确认并绑定</button>
  </div>
</template>

<script>
  import {bindUser, findWechatBind} from '@/api'
  import cell from '@/components/cell'

  export default {
    data() {
      return {
        list: [],
        loading: false,
        params: this.$route.query,
        thirdId: sessionStorage.getItem('thirdId'),
        companyCode: sessionStorage.getItem('companyCode'),
        relationShip: '我家',
        sexVisible: false,  //选择器的显示与隐藏
        slots: [
          {
            flex: 1,
            values: ['我家', '父母', '房东', '朋友'],
            className: 'slot1',
            textAlign: 'center',
          }
        ],
        ifUse: sessionStorage.getItem('ifUse'),
        ylDetail: {}
      }
    },
    methods: {
      // 绑定用户
      bindUser() {
        const data = {
          relationShip: this.relationShip,
          customerId: this.params.id,
          customerCode: this.params.code,
          customerYhkh: this.params.yhkh
        }

        if(this.ylDetail.pwd) {
            this.$router.push({
              path: '/jymm',
              query: {
                ...data,
                idNumber: this.$route.query.idNumber,
                pwd: this.ylDetail.pwd
              }
            })
        } else {
          bindUser(data).then(res => {
            this.$router.push(sessionStorage.getItem('path'))
          })
        }
      },
      onValuesChange(picker, values) {
        //console.log(values)
        this.relationShip = values[0];
        this.sexVisible = false;
      },
    },
    components: {
      cell
    },
    mounted() {
      findWechatBind({
        companyCode: sessionStorage.getItem('companyCode'),
        customerId: this.$route.query.id
      }).then((res) => {
        this.ylDetail = res.data
      });
    }
  }
</script>

<style scoped>
  .customer {
    padding: 0 3%;
    min-height: 90%;
  }

  .cell_item {
    display: flex;
    justify-content: space-between;
    padding: 12px 0;

    border-bottom: 1px solid #f1f1f1;
  }

  .cell_content {
    font-size: 15px;
  }

  .cell_label {
    font-size: 13px;
    min-width:80px ;
  }

  .btn_bind {
    width: 94%;
    margin-left: 3%;
    /*margin-top: 200px;*/
  }

  .div_fenzu {
    display: flex;
    justify-content: space-between;
    background: #fff;
    line-height: 43px;
    /* padding: 0 3%; */

  }

  .tit_tip {
    margin: 5px 2%;
    color: #8c939d;
  }

  .customer .mint-popup {
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/yhBind/Customer.vue